module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1Bjly"))).then(() => parcelRequire('hEqeo'));